import { configureStore } from '@reduxjs/toolkit';
import raspberryEraseStationReducer from './raspberryEraseStationSlice'

export const store = configureStore({
    reducer: {
        raspberryEraseStation: raspberryEraseStationReducer
    },
})